import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import {isAuthenticated} from '../auth';
import { Link, useParams } from "react-router-dom";
import { Trash2, AlertTriangle, ArrowLeft } from "lucide-react";
import CheckboxFilter from "../pageInside/CheckBoxFilterValue";
import { getCategoriesByID, readFilterValue, getFilterByID, linkVFTC, UnlinkVFTC} from "../auth/apiCategory";
import Modal from 'react-bootstrap/Modal';
import "./adminPages.css";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  red: "#ef4444", redLt: "#fee2e2",
  greenLt: "#d1fae5",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

const CreatCategory = props => {
    const {
        infoSource,
        laguangeElakay
            } = props
    let params = useParams()
    const [filter, setfilter] = useState([]);
    const [filterSel, setFilterSel] = useState([]);
    const [categories, setCategories] = useState([]);
    const [error] = useState(false);
    const [success] = useState(false);
    const [message, setMessage] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showDeleteAgree, setDeleteAgree] = useState(false);
    const [chek, setChek] = useState(false);
    const [seletName, setSeletName] = useState('');
    const handl = (a) => {
        setChek(a)
    }

    // destructure user and token from localstorage
    const {token } = isAuthenticated();
    // const name = props.match.params.nv
    const filterID = params.filterId
    const catID = params.categoryId

    // creat button filter is true
    const filterButton = true

    // load categories and set form data
    const loadFiltersBYID = (catID, filterID) => {
        readFilterValue(catID, filterID).then(data => {
            if (data.error) {
            } else {
                setFilterSel(data.filter[0].Filters)

            }
        });
    };

    const handleToggle = (catID, filID, name, token) => () => {
        // return the first index or -1
        linkVFTC(catID, filID, {name}, token).then(data => {
            if (data.error) {
            } else {
                if (data.Success) {
                    loadFiltersBYID(catID, filID)
                } else {
                    SubmitB(name)
                }
                checkSel(filID)

            }
        });
    };

    const removeFilter = (catID, filID, name, token) => {
        UnlinkVFTC(catID, filID, {name}, token).then(data => {
            if (data.error) {
            } else {
                loadFiltersBYID(catID, filID)
                setDeleteAgree(false)
                setChek(false)
                checkSel(filID)

            }
        });

    };

    const loadFilterSel = async (catID, token) => {
             try {
                              const encryptedData = await getCategoriesByID(catID);
                              const data = encryptedData;
                                 if (data.error) {
                                    throw new Error(data.error)
                                    } else {
                                 setCategories(data.cartegory)
                                // setFilterSel(data.filter);
                                setLoading(false)
                                }
                           } catch (err) {
                    console.error("Erreur lors du chargement de l'utilisateur :", err);
                  }
    };


    const loadFilters = (filterID, token) => {
        getFilterByID(filterID, token).then(data => {
            if (data.error) {
            } else {
                setfilter(data)
            }
        });
    };

    useEffect(() => {
        loadFilters(filterID)
        loadFiltersBYID(catID, filterID)
        loadFilterSel(catID, token)
    }, [catID, filterID, token])

    const SubmitB = (name) => {
        setSeletName(name)
        setDeleteAgree(true)

    }

    const checkSel = (a) => {

        let c

        filterSel.forEach(Item => {
            if (a === Item) {
                c = true
            }
        })
        return c
    }

    // ─── Shared primitives ───────────────────────────────────────────────────
    const showSuccess = () => !success ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.greenLt, borderRadius: 8, border: "1px solid #86efac", marginBottom: 14 }}>
        <span style={{ fontSize: 12, color: "#065f46", fontWeight: 500 }}>{message}</span>
      </div>
    );

    const showError = () => !error ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 14 }}>
        <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{error}</span>
      </div>
    );

    const deleteAgree = (catID, filID, name,  token) => (
      <Modal show={showDeleteAgree} onHide={() => setDeleteAgree(false)} centered aria-labelledby="delete-cat-filter-value-title">
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="delete-cat-filter-value-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.redLt, color: "#991b1b", flexShrink: 0 }}>
              <Trash2 size={16} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {infoSource.language(infoSource, "title", "delThtems")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
          <p style={{ fontSize: 13, color: D.txt2 }}>
            {infoSource.language(infoSource, "title", "surToDelete")}
            <span style={{ color: D.red, fontWeight: 700 }}> {name}</span>
          </p>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: D.txt2, cursor: "pointer" }}>
            <input
              onChange={() => handl(chek ? false : true)}
              type="checkbox"
              checked={chek}
              style={{ width: 16, height: 16, cursor: "pointer" }}
            />
            {infoSource.language(infoSource, "title", "chButAgree")}
          </label>
        </Modal.Body>
        <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
          <button
            onClick={chek ? () => removeFilter(catID, filID, name, token) : undefined}
            disabled={!chek}
            style={{
              padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
              fontFamily: D.font, cursor: chek ? "pointer" : "not-allowed",
              background: chek ? D.red : "#cbd5e1", color: chek ? "#fff" : "#94a3b8",
            }}
          >
            {infoSource.language(infoSource, 'Button', "submit")}
          </button>
        </Modal.Footer>
      </Modal>
    );

    const CategoryFom = () => (
        <div className="admin-grid-2">
            <div>
                <CheckboxFilter
                 infoSource ={infoSource}
                    handleToggle={handleToggle}
                    filter={filter}
                    filterSel={filterSel}
                    catID={catID}
                    token={token}
                    checkSel={checkSel}
                />
            </div>
            <div>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                    <h3 style={{ fontSize: 14, fontWeight: 700, color: D.txt1, margin: 0 }}>
                        {categories.name && categories.name[0]} {infoSource.language(infoSource, "Link", "filValue")}
                    </h3>
                </div>
                {showSuccess()}
                {showError()}

                <div className="admin-card" style={{ overflow: "hidden" }}>
                    {filterSel?.map((c, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 16px", borderBottom: `1px solid ${D.border}` }}>
                            <span style={{ flex: 1, fontSize: 13, color: D.txt1, fontWeight: 500 }}>{c}</span>
                            <button
                              type="button"
                              onClick={() => SubmitB(c)}
                              style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                              onMouseEnter={e => { e.currentTarget.style.background = D.redLt; e.currentTarget.style.color = D.red; }}
                              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                            >
                              <Trash2 size={15} />
                            </button>
                            {(c === seletName) && deleteAgree(catID, filterID, c, token)}
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );

    const createFilterProduct = (filterButton) => (
            filterButton && (
                <Link to={`/filter/${catID}`} style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: D.blue, textDecoration: "none", marginTop: 16, marginRight: 18 }}>
                    {infoSource.language(infoSource, "Link", "ViElakayFil")}
                </Link>
            ))

    const createCategoryButton = () => (
            <Link to={`/category`} style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: D.blue, textDecoration: "none", marginTop: 16 }}>
                <ArrowLeft size={14} />
                {infoSource.language(infoSource, "Button", "VieElaCat")}
            </Link>
    )

    return (
        <Layout
            className="container blockEl"
            SliderPunShow={false}
            infoSource ={infoSource}
            loading={loading}
             {...infoSource?.allSettings?.layout}
        >
             <div style={infoSource.styleNav}>
            <div className="admin-container" style={{ fontFamily: D.font }} onBlur={() => setMessage("")}>
                {CategoryFom()}
                <div>
                    {createCategoryButton()}
                    {createFilterProduct(filterButton)}
                </div>
            </div>
            </div>
        </Layout>
    );

};

export default CreatCategory;
